module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addDate(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-left": 65,
      "nudge-bottom": 10,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          }
        }, on), [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.date, "DD.MM.YYYY")))])])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de"
    },
    on: {
      "input": _vm.getDatepicker
    },
    model: {
      value: (_vm.datepicker),
      callback: function($$v) {
        _vm.datepicker = $$v
      },
      expression: "datepicker"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addDate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    staticClass: "pa-0 my-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-2 ma-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "12",
      "sm": "7",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Bundesbruder",
      "items": _vm.bundesbruderselect
    },
    model: {
      value: (_vm.bbrID),
      callback: function($$v) {
        _vm.bbrID = $$v
      },
      expression: "bbrID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-sm-and-up pr-1 mb-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.stricheSet(-1)
      }
    }
  }, [_vm._v("-1")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "6",
      "sm": "3",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "min": "0",
      "type": "number",
      "name": "",
      "label": "Striche",
      "id": ""
    },
    model: {
      value: (_vm.striche),
      callback: function($$v) {
        _vm.striche = $$v
      },
      expression: "striche"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-sm-and-up pr-1 mb-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.stricheSet(+1)
      }
    }
  }, [_vm._v("+1")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "6",
      "sm": "2",
      "md": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "tabindex": "-1",
      "block": "",
      "height": "40px",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.showStrichpreis = true
      }
    }
  }, [_vm._v("Strichpreis"), _c('br'), _vm._v(_vm._s(_vm._f("money")(_vm.strichpreis)))])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "clearable": "",
      "label": "EKP-Getränke",
      "items": _vm.getrankeselect
    },
    on: {
      "input": function($event) {
        _vm.anzahlEkp = 1
      }
    },
    model: {
      value: (_vm.ekp),
      callback: function($$v) {
        _vm.ekp = $$v
      },
      expression: "ekp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "min": "0",
      "type": "number",
      "name": "",
      "label": "Anzahl",
      "id": ""
    },
    model: {
      value: (_vm.anzahlEkp),
      callback: function($$v) {
        _vm.anzahlEkp = $$v
      },
      expression: "anzahlEkp"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "4",
      "sm": "3",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hide-details": "",
      "append-icon": "euro",
      "outlined": "",
      "name": "",
      "label": "Pauschal",
      "id": ""
    },
    model: {
      value: (_vm.pauschal),
      callback: function($$v) {
        _vm.pauschal = $$v
      },
      expression: "pauschal"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-1 mb-2",
    attrs: {
      "cols": "8",
      "sm": "5",
      "md": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "feld",
    attrs: {
      "dense": "",
      "hint": _vm.pauschal && !_vm.grund ? 'Du musst einen Grund für den Pauschalpreis angeben.' : '',
      "hide-details": "auto",
      "outlined": "",
      "name": "",
      "label": "Grund",
      "id": ""
    },
    model: {
      value: (_vm.grund),
      callback: function($$v) {
        _vm.grund = $$v
      },
      expression: "grund"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "height": "40px",
      "disabled": !_vm.bbrID,
      "dark": !!_vm.bbrID
    },
    on: {
      "click": _vm.saveStriche
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 my-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 504px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Preis")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Anzahl")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Gesamt")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.stricheHeute), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bbr))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs-only"
    }, [_vm._v(_vm._s(item.grund))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")((item.preis * item.anzahl))))]), _vm._v(" "), (item.id) ? _c('td', {
      on: {
        "click": function($event) {
          return _vm.deleteStrich(item.id)
        }
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e()])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.strichAnzahl) + " Striche -\n    " + _vm._s(_vm._f("money")(_vm.summe)) + "\n  ")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "30%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStrichpreis),
      callback: function($$v) {
        _vm.showStrichpreis = $$v
      },
      expression: "showStrichpreis"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [_c('div', [_vm._v("Strichpreis festlegen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStrichpreis = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Strichpreis",
      "dense": "",
      "outlined": "",
      "hint": "Der Strichpreis wird für spätere Eintäge gespeichert.",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.strichpreisNeu),
      callback: function($$v) {
        _vm.strichpreisNeu = $$v
      },
      expression: "strichpreisNeu"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStrichpreis = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.saveStrichpreis()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55052073"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/stricheNeu.vue
// module id = 781
// module chunks = 15